import React from "react";
import "./index.scss";

interface IProps {
	checked: boolean;
	changeEvent: (e: React.ChangeEvent) => void;
}

export default class ToggleSwitch extends React.Component<IProps> {
	render() {
		return (
			<label className="switch">
				<input type="checkbox"
					checked={this.props.checked}
					onChange={this.props.changeEvent} />
				<span className="sliderthumb round"></span>
			</label>
		);
	}
}
